import type { RouteRecordRaw } from 'vue-router';
import { USER_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const userRoutes: RouteRecordRaw = {
  path: '/user',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, i18n },
  children: [
    {
      name: USER_ROUTE_NAME.PROFILE,
      path: 'profile',
      component: () => import('./User.vue'),
    },
  ],
};
